import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'

const getPdf = async (title, element) => {
  return new Promise((resolve, reject) => {
    Array.from(element.getElementsByTagName("img")).forEach(item=>{
      let img =new Image()
      img.src= item.src
      item.style=`width:${img.width*item.height/img.height}px`
    })
    Array.from(element.getElementsByClassName("el-row")).forEach(item=>{
       item.lastChild.style = `width:${item.lastChild.style.width};border-right: 1px solid rgba(230, 227, 227, 1);`
     })
     console.log(element)
    html2canvas(element, {taintTest: true, useCORS: true, logging: false,allowTaint:false, }).then(function(canvas) {
      var pdf = new JsPDF('p', 'mm', 'a4')
      var ctx = canvas.getContext('2d'),
        a4w = 190,
        a4h = 277, //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
        imgHeight = Math.floor((a4h * canvas.width) / a4w), //按A4显示比例换算一页图像的像素高度
        renderedHeight = 0
      while (renderedHeight < canvas.height) {
        var page = document.createElement('canvas')
        page.width = canvas.width
        page.height = Math.min(imgHeight, canvas.height - renderedHeight) //可能内容不足一页
        page
          .getContext('2d')
          .putImageData(
            ctx.getImageData(
              0,
              renderedHeight,
              canvas.width,
              Math.min(imgHeight, canvas.height - renderedHeight)
            ),
            0,
            0
          )
        pdf.addImage(
          page.toDataURL('image/jpeg', 1.0),
          'JPEG',
          10,
          10,
          a4w,
          Math.min(a4h, (a4w * page.height) / page.width)
        ) //添加图像到页面，保留10mm边距

        renderedHeight += imgHeight
        if (renderedHeight < canvas.height) pdf.addPage() //如果后面还有内容，添加一个空页
        // delete page;
      }
      var fileName = pdf.output('blob')
      fileName.name = title+'.pdf'
      resolve(fileName)
    })
  })
}

export default getPdf
